"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exportLoginAudits = exports.ExportLoginAudits = exports.ExportLoginAuditsActionTypes = exports.LoginAuditApiActionTypes = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _fluxActions = require("flux-actions");

var _I18n = _interopRequireDefault(require("I18n"));

var _actions = require("settings-ui-lib/utils/actions");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-lib/constants/RequestStatusTypes"));

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-lib/utils/namespacedKeyMirror"));

var LoginAuditApiActionTypes = (0, _namespacedKeyMirror.default)({
  EXPORT: null
}, 'loginAudit');
exports.LoginAuditApiActionTypes = LoginAuditApiActionTypes;
var ExportLoginAuditsActionTypes = (0, _actions.createRequestTypes)(LoginAuditApiActionTypes.EXPORT);
exports.ExportLoginAuditsActionTypes = ExportLoginAuditsActionTypes;
var ExportLoginAudits = (0, _actions.createRequestActions)(ExportLoginAuditsActionTypes, {
  successMetaCreator: function successMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(ExportLoginAuditsActionTypes.base, _RequestStatusTypes.default.SUCCEEDED), (0, _actions.createSuccessNotificationMeta)(_I18n.default.text('accountdefaults.security.loginAuditExport.notifications.success')));
  },
  failureMetaCreator: function failureMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(ExportLoginAuditsActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(_I18n.default.text('accountdefaults.security.loginAuditExport.notifications.failure')));
  }
});
exports.ExportLoginAudits = ExportLoginAudits;
var exportLoginAudits = (0, _fluxActions.createAction)(LoginAuditApiActionTypes.EXPORT);
exports.exportLoginAudits = exportLoginAudits;